import { useState } from 'react';
import { Heading, SkeletonText, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { Icon } from '@mercator-gcp/grout';
import { TabsList } from 'components/elements/TabsList';
import { FlexRow } from 'components/layout/FlexRow';
import { Panel } from 'components/layout/Panel';
import CreatedAtDateDisplay from 'components/widgets/ProjectDetails/CreatedAtDateDisplay';
import { ActivityList } from 'pages/ProjectDetails/ActivityList';
import SummaryView from 'pages/ProjectDetails/SummaryView';
import { Project } from 'types';
import type { ProjectActivitySummary } from 'types/ActivitySummary';

const HEADINGS = ['Summary', 'All Events'];

const titleRow = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '148%',
  letterSpacing: '-0.01em',
};

const panelParentStyle = {
  paddingTop: 'padding_16',
};

const panelStyle = {
  padding: 0,
  paddingBottom: 'padding_8',
};

const createdAtStyle = {
  marginTop: 'padding_8',
};
type Props = {
  projectActivitySummary?: ProjectActivitySummary | null;
  isLoading: boolean;
  isError: boolean;
  projectSlug: Project['slug'];
  projectCity: string;
  projectEvents?: any;
  isLoadingProjectEvents?: boolean;
};

const ProjectActivitySection = ({
  projectSlug,
  projectCity,
  projectActivitySummary,
  isLoading,
  isError,
  projectEvents,
  isLoadingProjectEvents,
}: Props) => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabsChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <Panel title="Project Stages" icon={<Icon name={Icon.Name.ArrowTrendUp} />}>
      <Tabs variant="enclosed" onChange={handleTabsChange} isLazy>
        <FlexRow>
          <FlexRow.Left>
            <Heading sx={titleRow}>{HEADINGS[tabIndex]}</Heading>
          </FlexRow.Left>
          <FlexRow.Right>
            <TabsList className="hide-on-print" tabLabels={HEADINGS} />
          </FlexRow.Right>
        </FlexRow>

        <TabPanels sx={panelParentStyle}>
          <TabPanel sx={panelStyle}>
            <SkeletonText isLoaded={!isLoading}>
              <SummaryView
                projectActivitySummary={projectActivitySummary ?? null}
                isLoading={isLoading}
                projectSlug={projectSlug}
                isError={isError}
              />
              <CreatedAtDateDisplay
                createdAtDate={projectActivitySummary?.start_date || ''}
                sx={createdAtStyle}
              />
            </SkeletonText>
          </TabPanel>
          <TabPanel sx={panelStyle}>
            <SkeletonText isLoaded={!isLoadingProjectEvents}>
              <ActivityList
                projectId={projectSlug}
                activities={projectEvents || []}
                city={projectCity || ''}
              />
            </SkeletonText>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Panel>
  );
};

export default ProjectActivitySection;
